import React from "react";

// 1. IMPORT YOUR LOCAL LOGO IMAGES HERE
import logo1 from "./ClImages/cl1.png";
// import logo2 from "./ClImages/cl2.png";
// import logo3 from "./ClImages/cl3.png";
import logo4 from "./ClImages/cl4.png";
import logo5 from "./ClImages/cl5.png";
import logo6 from "./ClImages/cl6.webp";
import logo7 from "./ClImages/cl7.png";
import logo8 from "./ClImages/cl8.png";
import logo9 from "./ClImages/cl9.png";
import logo10 from "./ClImages/cl10.png";
import logo11 from "./ClImages/cl11.png";
import logo12 from "./ClImages/cl12.png";
import logo13 from "./ClImages/cl13.png";
// import logo14 from "./ClImages/cl14.png";
import logo15 from "./ClImages/cl15.png";
// import logo16 from "./ClImages/cl16.png";
import logo17 from "./ClImages/cl17.jpeg";

const PARTNERS = [
  { id: 1, name: "Partner 1", logo: logo1 },
//   { id: 2, name: "Partner 2", logo: logo2 },
//   { id: 3, name: "Partner 3", logo: logo3 },
  { id: 4, name: "Partner 4", logo: logo4 },
  { id: 10, name: "Partner 10", logo: logo10 },
  { id: 5, name: "Partner 5", logo: logo5 },

  { id: 11, name: "Partner 11", logo: logo11 },
  { id: 12, name: "Partner 12", logo: logo12 },
  { id: 8, name: "Partner 8", logo: logo8 },

  { id: 9, name: "Partner 9", logo: logo9 },
  { id: 6, name: "Partner 6", logo: logo6 },
  { id: 7, name: "Partner 7", logo: logo7 }, 

  { id: 13, name: "Partner 13", logo: logo13 },
//   { id: 14, name: "Partner 14", logo: logo14 },
  { id: 15, name: "Partner 15", logo: logo15 },
  // { id: 16, name: "Partner 16", logo: logo16 },
  { id: 17, name: "Partner 17", logo: logo17 },
];

export default function Collaborations() {
  return (
    <div className="min-h-screen bg-[#f8f9fc] py-16 lg:py-24">
      
      {/* ── HEADER ── */}
      <div className="text-center max-w-3xl mx-auto px-4 mb-14">
        <span className="inline-block text-xs font-extrabold tracking-[0.2em] uppercase bg-[#e8e6fb] border border-[#1800ad] text-[#1800ad] px-4 py-1.5 rounded-full mb-4">
          ★ Collaborations
        </span>
        <h1 className="text-4xl sm:text-5xl font-black text-gray-900 mb-5">
          Our Trusted <span className="text-[#d11210]">Partners</span>
        </h1>
        <p className="text-gray-500 text-lg">
          We collaborate with leading educational institutions and organizations to provide the best training and placement opportunities for our students.
        </p>
      </div>

      {/* ── CSS to hide the scrollbar cleanly on mobile ── */}
      <style>{`
        .hide-scroll::-webkit-scrollbar {
          display: none;
        }
        .hide-scroll {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>

      {/* ── LOGO FLEX CONTAINER (Scrollable on Mobile, Wrapped & Centered on Desktop) ── */}
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <div className="flex flex-nowrap sm:flex-wrap overflow-x-auto sm:overflow-visible justify-start sm:justify-center gap-4 sm:gap-6 pb-6 sm:pb-0 hide-scroll snap-x snap-mandatory sm:snap-none">
          {PARTNERS.map((partner) => (
            <div
              key={partner.id}
              // Width calculations ensure 3, 4, or 5 items per row cleanly on respective breakpoints, matching original grid look
              className="w-[220px] sm:w-[calc(33.333%-16px)] md:w-[calc(25%-18px)] lg:w-[calc(20%-19.2px)] flex-shrink-0 snap-center bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 flex items-center justify-center hover:shadow-xl hover:-translate-y-1 hover:border-[#1800ad] transition-all duration-300 aspect-[4/3] group cursor-pointer"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="w-full h-full object-contain transition-transform duration-300 ease-in-out group-hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}